module.exports = __webpack_public_path__ + "img/mobile-security.590656a2.png";